import { jsx as _jsx } from "react/jsx-runtime";
import Script from "next/script";
/**
 * Loads Seznam's rc.js measurement script. The hits themselves are fired by the Seznam
 * tracker in response to analytics events, not on page load.
 */
export function SeznamCounter({ rtgId }) {
    if (!rtgId) {
        return null;
    }
    return _jsx(Script, { id: "seznam-rc", src: "https://c.seznam.cz/js/rc.js", strategy: "afterInteractive" });
}
